import React, { PropTypes } from 'react'

import './ServiceDetails.scss'

import { formatDate } from 'utils/dates'

const ServiceDetails = ({ aliada, datetime, estimatedHours, cost }) => {
  const newServiceDateFormat = 'dddd D [de] MMMM'
  const newServiceDate = formatDate(newServiceDateFormat, datetime)

  const timeFormat = 'h:mm A'
  const newServiceTime = formatDate(timeFormat, datetime)

  return (
    <div>
      <div className='ServiceDetails-row'>
        <div>
          <p className='ServiceDetails-label'>
            Aliada
            <span>{aliada.firstName}</span>
          </p>
        </div>
      </div>

      <div className='ServiceDetails-row'>
        <div>
          <p className='ServiceDetails-label'>
            Dia del servicio
            <span>{newServiceDate}</span>
          </p>
        </div>
      </div>

      <div className='ServiceDetails-row'>
        <div>
          <p className='ServiceDetails-label'>
            Hora del servicio
            <span>{newServiceTime}</span>
          </p>
        </div>

        <div>
          <p className='ServiceDetails-label'>
            Duración del servicio
            <span>{estimatedHours} horas</span>
          </p>
        </div>
      </div>

      <div className='ServiceDetails-row'>
        <div>
          <p className='ServiceDetails-label'>
            Costo
            <span>${cost}</span>
          </p>
        </div>
      </div>
    </div>
  )
}

ServiceDetails.displayName = 'ServiceDetails'
ServiceDetails.propTypes = {
  aliada: PropTypes.shape({
    firstName: PropTypes.string.isRequired
  }).isRequired,
  datetime: PropTypes.string.isRequired,
  estimatedHours: PropTypes.number.isRequired,
  cost: PropTypes.number.isRequired
}
ServiceDetails.defaultProps = {}

export default ServiceDetails



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/RescheduleConfirm/components/ServiceDetails/ServiceDetails.js